export const CAREPLAN_SURVEY_STATUS = {
  satisfied: "satisfied",
  not_satisfied: "not_satisfied",
} as const;

export const SURVEY_PREVIEW_MODE = {
  smart: "smart",
  collapsed: "collapsed",
} as const;
